module.exports = __webpack_public_path__ + "static/media/smsVerify.8afe3af2.svg";